export default __webpack_public_path__ + "static/media/Reto-Nyf.49a94551.png";